import { Select } from 'antd';
import Text from 'components/Text/Text';
import { scheduledPushStatuses } from 'appConstants';
import { useTranslation } from 'react-i18next';
import {
	IScheduleViewContext,
	ScheduleViewContext,
} from '../../../scheduleViewContext/scheduleViewState/scheduleViewContext';
import React, { useContext, useRef } from 'react';
import style from './StatusSelect.module.scss';

const { Option } = Select;

const StatusSelect: React.FC = () => {
	const { setStatus, status } = useContext<IScheduleViewContext>(ScheduleViewContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { t } = useTranslation('form');

	return (
		<div className={style.container} data-test="StatusSelect">
			<Text translationNameSpace="form" translationKey="statusLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setStatus}
				value={status}
				listItemHeight={scheduledPushStatuses.length}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				allowClear={true}
				placeholder={t('selectPlaceholder')}>
				{scheduledPushStatuses.length ? (
					<>
						<Option className={style.disabledItem} value="empty" disabled={true}>
							<Text
								translationNameSpace="form"
								translationKey="selectAnyItemPlaceholder"
								asFragment={true}
							/>
						</Option>
						{scheduledPushStatuses.map((el) => (
							<Option className={style.listItem} value={el} key={el}>
								{el}
							</Option>
						))}
					</>
				) : null}
			</Select>
		</div>
	);
};

export default StatusSelect;
